import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from "./styles";

import Form from './Form';

const useStyles = makeStyles(theme => styles(theme));

export const CgbContactColumnsBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`contact-columns ${props.attributes.className ? props.attributes.className : ''} ${classes.contactColumns} ${classes.contactColumnsTheme}`}>
        <div className="content-col">
            {blocks[0]}
            {blocks[1]}
            <div className="image-links">
                {blocks[2]}
                {blocks[3]}
            </div>
        </div>
        <div className="form-col">
            <Form />
        </div>
    </div>
};

export const CgbContactColumnsBlockFragment = graphql`
  fragment CgbContactColumnsBlock on WpBlock {
    ... on WpCgbContactColumnsBlock {
        name
        attributes {
            ... on WpCgbContactColumnsBlockAttributes {
                className
            }
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbContactColumnsBlockPreview = `
    ... on CgbContactColumnsBlock {
        name
        attributes {
            ... on CgbContactColumnsBlockAttributes {
                className
            }
        }
    }
`;